<script>
  import { createEventDispatcher } from "svelte"
  import Button from "./Button.svelte"

  export let toggled = false
  export let disabled = false

  let borderColor = "var(--grey)"
  let backgroundColor = "var(--main-background-color)"
  $: if (disabled) {
    borderColor = "var(--dimmed-background-color)"
  }

  const dispatch = createEventDispatcher()

  function toggle() {
    if (disabled) return
    toggled = !toggled
    dispatch("toggle", {
      toggled: toggled,
    })
  }
</script>

<Button on:click={toggle} {disabled} {backgroundColor} {borderColor}>
  {#if !disabled}
    {#if toggled}
      <svg class="minus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <line vector-effect="non-scaling-stroke" y1="9" x2="18" y2="9" />
      </svg>
    {:else}
      <svg class="plus" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <line vector-effect="non-scaling-stroke" x1="9" x2="9" y2="18" />
        <line vector-effect="non-scaling-stroke" y1="9" x2="18" y2="9" />
      </svg>
    {/if}
  {/if}
</Button>

<style>
  svg {
    height: calc(var(--line-height-m) * 0.6);
    width: calc(var(--line-height-m) * 0.6);
    display: block;
    stroke: var(--grey);
    stroke-width: 0.07em;
  }
</style>
